export default __webpack_public_path__ + "static/media/bg.9736e0dc.jpg";